import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        selectRevision: [
            "Select revision to copy all education records to:",
            "Выберите ревизию в которую нужно скопировать все записи об образовании:",
        ][index],
        modalTitle: ["Copy Education", "Копировать образование"][index],
        successCopyMessage: ["Education records copied", "Записи об образовании скопированы"][index],
        errorCopyMessage: [
            "Error when copying education records",
            "Ошибка копирования записей об образовании",
        ][index],
        noRevisions: [
            "You don't have revisions to copy education to",
            "У вас нет ревизий в которые можно скопировать образование",
        ][index],
    };
};
